import React, { useState, useEffect, useRef } from "react";
import {
    Box,
    Typography,
    Button,
    IconButton,
    Dialog,
    useMediaQuery,
    useTheme,
    Modal,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { downarrow, glasscurve, mbglasscurve } from "../../../../assets";
import CloseIcon from "@mui/icons-material/Close";
import { gsap } from "gsap";
import CheckMarkIcon from '../../../../assets/images/Mentoring/CheckMark.png';
import IndividualMentoringForm from "../../../../Components/IndividualMentoringForm";
import OrganizationalMentoringForm from "../../../../Components/OrganizationalMentoringForm";
import SmoothWaveText from "../../../../Components/SmoothWaveText";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';


type CardData = {
    step: string;
    title: string;
    year: string;
    description: string;

    popupTitle: string;
    popupSubTitle?: string;

    popupIntro?: React.ReactNode[];


    workOn?: string[];

    whoFor?: string[];
    outcomeTitle?: string;

    outcome?: string[];

    ctaText?: string;

    left: {
        xs: string;
        md: string;
        lg: string;
    };
    top: {
        xs: string;
        md: string;
        lg: string;
    };
};


const organizationalSteps: CardData[] = [
    {
        step: " 1",
        year: "",
        title: "LUXURY SALES MASTERY",
        description:
            "Build an LUXURY SALES FOUNDATION ambitious & sharp sales team that engages clients with confidence & clarity that enriches their client engagement.",
        popupTitle: "LUXURY SALES MASTERY",
        popupSubTitle: "",

        popupIntro: [
            <>
                This is for sales teams and aspiring sales professionals stepping into {" "}
                <b style={{ color: "#0f63a5" }}>premium and luxury real estate sales</b> {" "}who need the right foundation before handling high-value buyers.
            </>,
            <>
                The focus is on how luxury buyers think, how trust is built early, and how conversations are handled without pressure or over-selling.

            </>,
        ],


        workOn: [
            " Communicating with premium buyers with confidence and restraint",
            "Structuring luxury conversations without sounding sales-driven",
            "Understanding trust, credibility, and expectations at the top end",
            " Positioning yourself and the project correctly from the first interaction",

        ],

        whoFor: [
            "Sales teams and professionals transitioning into premium and luxury segments Builders aligning teams before scaling luxury inventory"
        ],
        outcomeTitle: "Duration",
        outcome: [
            "Planned based on team size, problem areas and sales goals",
            "Discussed during the strategy call",

        ],

        ctaText: "Enquire Now",

        // popupDescription:
        //     "This level focuses on premium sales psychology, elite communication, and luxury buyer behavior.",
        left: { xs: "50%", md: "26%", lg: "32%" },
        top: { xs: "32%", md: "28%", lg: "28%" },
    },
    {
        step: " 2",
        year: "",
        title: "HIGH TICKET SALES MASTERY",
        description:
            "Strengthen the ability of your team & how it handles high value buyers, complex objections, & unusual decision cycles",
        popupTitle: "HIGH TICKET SALES MASTERY",
        popupSubTitle: "",

        popupIntro: [
            <>
                This level is for builders and senior sales professionals operating in the {" "}
                <b style={{ color: "#0f63a5" }}> top end of the luxury market</b> {""} ,where buyers are informed, expectations are high, and mistakes are costly.
            </>,
            <>
                The work here goes beyond presentation. It focuses on {""} <b style={{ color: "#0f63a5" }}> judgment, discretion, and decision control</b> {" "}in high-value conversations.

                objections, & build a strong base for long-term growth.
            </>,
        ],


        workOn: [
            " Understanding how ultra-luxury buyers evaluate value and trust",
            " Handling high-stakes conversations without pressure or overselling",
            "Managing long sales cycles, private negotiations, and sensitive objections",
            "Aligning personal presence and project positioning at the luxury end",

        ],

        whoFor: [
            "Senior sales professionals handling premium and ultra-luxury inventoryn Builder teams working with HNI, UHNI, and NRI buyer segments"
        ],
        outcomeTitle: "Duration",
        outcome: [
            "Planned based on team size, project stage, and sales goals",
            "Discussed during the initial conversation",

        ],

        ctaText: "Enquire Now",

        // popupDescription:
        //     "Advanced negotiation, ultra-high-net-worth client handling, and legacy-level brand positioning.",
        left: { xs: "50%", md: "52%", lg: "52%" },
        top: { xs: "54%", md: "36%", lg: "36%" },

    },
    {
        step: " 3",
        year: "",
        title: "ORGANIZATIONAL MENTORING & BUSINESS COACHING",
        description:
            "Work closely on leadership, team alignment, and execution systems to improve consistency across projects",
        popupTitle: "ORGANIZATIONAL MENTORING & BUSINESS COACHING",
        popupSubTitle: "",

        popupIntro: [
            <>
                This engagement is designed for {" "}
                <b style={{ color: "#0f63a5" }}>builders and leadership teams </b> {""}  who want tighter alignment between people, sales thinking, and on-ground execution.
            </>,
            <>
                The focus is not on training individuals , it’s on improving how the  {""} <b style={{ color: "#0f63a5" }}>organization thinks, communicates, and performs</b>
                across projects.

            </>,
        ],


        workOn: [
            "Aligning sales leadership with project goals and market reality",
            " Strengthening how teams communicate, plan, and execute",
            " Identifying gaps in positioning, decision flow, and accountability",
            " Working closely with leadership on clarity, structure, and direction",

        ],

        whoFor: [
            "Builders, founders, and sales head  Organizations looking to improve consistency across teams and projects Leadership teams preparing for scale or premium market expansion",
        ],
        outcomeTitle: "Duration",
        outcome: [
            "Planned based on team size, problem area , and business goals",
            " Discussed during the initial conversation",

        ],

        ctaText: "Enquire Now",

        // popupDescription:
        //     "Direct mentorship for leadership teams and elite organizational scaling.",
        left: { xs: "50%", md: "79%", lg: "71%" },
        top: { xs: "76%", md: "45%", lg: "44%" },

    },
];



const individualSteps: CardData[] = [
    {
        step: "LEVEL 1",
        year: "( 0 – 2 Years)",
        title: "BEGINNER’S PATH",
        description:
            "Build strong fundamentals, Confidence, Clarity & Concise Communication, in every Conversation.",

        popupTitle: "BEGINNER’S PATH TO EXCELLENCE",
        popupSubTitle: "( 0 – 2 Years in Real Estate)",

        popupIntro: [
            <>
                If you’re new to real estate or still finding your way, this program helps you {" "}
                <b style={{ color: "#0f63a5" }}>End the Guess work & Sets you up with clarity.</b>
            </>,
            <>
                It is built for professionals who wish to level up with confidence, handle
                objections, & build a strong base for long-term growth.
            </>,
        ],


        workOn: [
            "How to communicate with clients without sounding pushy or salesy",
            "How to handle site visits, inbound & outbound calls, and messaging",
            "How to handle common queries around pricing, credibility & trust",
            "How to remain consistent when deals fail",
            "Practice real-time scenarios prior to facing them live",
            "This isn’t theory. It’s about getting comfortable with uncomfortable conversations.",
        ],

        whoFor: [
            "Freshers, new agents & early-stage professionals",
            "People who feel stuck or lack confidence in client interactions",
            "Anyone who wants structure instead of a trial-and-error approach",
        ],
        outcomeTitle: "What Changes After This",
        outcome: [
            "You’ll think clearer",
            "You’ll speak better",
            "You’ll handle buyers with more confidence & control",
            "Most importantly , the second-guessing ends",
        ],

        ctaText: "Enquire Now",

        left: { xs: "50%", md: "26%", lg: "32%" },
        top: { xs: "31%", md: "29%", lg: "29%" },
    },
    {
        step: "LEVEL 2",
        year: "( 2 – 4 Years)",
        title: "SALES ACCELERATOR",
        description:
            "Refine your approach, handle objections better, & close deals consistently with control.",

        popupTitle: "SALES ACCELERATOR",
        popupSubTitle: "(2–4 Years in Real Estate)",

        popupIntro: [
            <>
                This is for professionals who already know the basics but want to {" "}
                <b style={{ color: "#0f63a5" }}>
                    close more consistently and handle buyers with confidence & control.
                </b>
            </>,
            <>
                If conversations & results don’t align, this level-up helps strengthen
                your approach and execution.
            </>,
        ],

        workOn: [
            "Sharper communication & objection handling",
            "Better control over client interactions",
            "Stronger follow-ups & deal momentum",
            "Live practice & role plays in high-pressure scenarios",
        ],

        whoFor: [
            "Mid level agents & professionals who are ready to level up from “occasional wins” to Consistent Wins",
        ],
        outcomeTitle: "",
        outcome: [

        ],

        ctaText: "Enquire Now",

        left: { xs: "51%", md: "51%", lg: "51%" },
        top: { xs: "52%", md: "38%", lg: "38%" },
    },

    {
        step: "LEVEL 3",
        year: "( 5+ Years)",
        title: "EXCLUSIVE PERSONALIZED MENTORING",
        description:
            "Work closely on advanced sales framing, negotiation frameworks, & long-term positioning in your market segment.",

        popupTitle: "EXCLUSIVE PERSONALIZED MENTORING",
        popupSubTitle: "(5+ Years in Real Estate)",

        popupIntro: [
            <>
                This is for experienced professionals who need new perspectives & strategies to level up, those need {" "}
                <b style={{ color: "#0f63a5" }}>
                    sharp thinking, constructive feedback, and real time experiences.

                </b>
            </>,
            <>
                The work happens with live deals, real clients, and actual decision making & closing.
            </>,
        ],

        workOn: [
            "One to One guidance on Real time sales scenarios ",
            "Direct work on Negotiations & Buyer Strategy",
            "Exposure to high value conversations & Closures",
            " Constructive feedback, beyond Classroom sessions",
        ],

        whoFor: [
            "Senior professionals who want to operate at a higher level, seeking growth & promotions, a step beyond sales & deals",

        ],
        outcomeTitle: "Duration",
        outcome: [
            "Flexible engagement based on fit and requirements"
        ],

        ctaText: "Enquire Now",
        left: { xs: "50%", md: "77%", lg: "70%" },
        top: { xs: "72%", md: "41%", lg: "43%" },
    },
];




const StepCard = ({
    step,
    year,
    title,
    description,
    onViewMore,
    index,
    isFlipped,
    onHover,
}: {
    step: string;
    year: string;
    title: string;
    description: string;
    onViewMore: () => void;
    index: number;
    isFlipped: boolean;
    onHover: () => void;
}) => {

    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

    const flipRef = useRef<HTMLDivElement>(null);
    const arrowRef = useRef<HTMLDivElement>(null);

    /* ================= ARROW BOUNCE ================= */
    useEffect(() => {
        if (!isDesktop || !arrowRef.current) return;

        gsap.to(arrowRef.current, {
            y: -10,
            duration: 0.8,
            repeat: -1,
            yoyo: true,
            ease: "power1.inOut",
        });
    }, [isDesktop]);

    /* ================= FLIP ================= */
    useEffect(() => {
        if (!flipRef.current) return;

        gsap.to(flipRef.current, {
            rotateY: isFlipped ? 180 : 0,
            duration: 0.9,
            ease: "power3.inOut",
        });
    }, [isFlipped]);


    /* ================= CARD UI (REUSED) ================= */
    const CardUI = ({ children }: { children: React.ReactNode }) => (
        <Box
            sx={{
                width: { xs: 282, sm: 230, md: 230 },
                height: { xs: 'auto', sm: 350, md: "auto" },
                borderRadius: "28px",
                background:
                // "linear-gradient(135deg, #1c5ea9, #33a6ea, #0d4677)",
                 "linear-gradient(180deg, rgb(67 92 142 / 90%) 0%, rgba(90, 141, 240, 0.92) 100%)",
                // "linear-gradient(180deg, rgba(11,18,32,0.9) 0%, rgba(90,141,240,0.92) 100%)",
                backdropFilter: "blur(16px)",
                WebkitBackdropFilter: "blur(16px)",
                border: "1.5px solid rgba(255,255,255,0.6)",
                boxShadow:
                    "0 24px 48px rgba(15,23,42,0.3), inset 0 0 0 1px rgba(255,255,255,0.22)",
                padding: "14px",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <Box
                sx={{
                    flex: 1,
                    borderRadius: "22px",
                    border: "1px solid rgba(255,255,255,0.35)",
                    padding: "18px",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                {children}

                <Button
                    fullWidth
                    onClick={onViewMore}
                    sx={{
                        height: 44,
                        borderRadius: "999px",
                        backgroundColor: "#ffffff",
                        color: "#0b1220",
                        fontWeight: 600,
                        mt: 2,
                        textTransform: "none",
                        "&:hover": { backgroundColor: "#f1f5f9" },
                    }}
                >
                    Learn More
                </Button>
            </Box>
        </Box>
    );

    return (
        <Box
            sx={{
                position: "relative",
                perspective: "1400px",
                cursor: isDesktop ? "pointer" : "default",
            }}
            onMouseEnter={onHover}
        // onMouseEnter={onEnter}
        // onMouseLeave={onLeave}
        >
            {/* ===== Arrow (outside card) ===== */}
            {isDesktop && (
                <Box
                    ref={arrowRef}
                    sx={{
                        position: "absolute",
                        top: -55,
                        left: "48%",
                        transform: "translateX(-50%)",
                        textAlign: "center",
                        zIndex: 5,
                        pointerEvents: "none",
                    }}
                >
                    <Box component="img" src={downarrow} sx={{ width: 26 }} />
                    <Typography variant="body2" sx={{ fontSize: 12, color: "rgba(15,23,42,0.6)" }}>
                        Hover me
                    </Typography>
                </Box>
            )}

            {/* ===== Flip Wrapper ===== */}
            <Box
                ref={flipRef}
                sx={{
                    position: "relative",
                    transformStyle: "preserve-3d",
                }}
            >
                {/* ---------- FRONT ---------- */}
                <Box sx={{ backfaceVisibility: "hidden" }}>
                    <CardUI>
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                mb: 3,
                            }}
                        >
                            <Typography variant="body2" sx={{ fontSize: 12, color: "rgba(255,255,255,0.8)" }}>
                                {step}
                            </Typography>
                            <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.8)" }}>
                                {year}
                            </Typography>
                        </Box>

                        <Typography
                            variant="h6"
                            sx={{
                                fontSize: { xs: 20, md: 18 },
                                fontWeight: 700,
                                color: "#fff",
                                mb: 2,
                            }}
                        >
                            {title}
                        </Typography>
                    </CardUI>
                </Box>

                {/* ---------- BACK (SAME UI) ---------- */}
                <Box
                    onClick={onViewMore}
                    sx={{
                        position: "absolute",
                        inset: 0,
                        transform: "rotateY(180deg)",
                        backfaceVisibility: "hidden",
                    }}
                >
                    <CardUI>
                        <Typography
                            variant="body2"
                            sx={{
                                // fontSize: 14,
                                color: "rgba(255,255,255,0.85)",
                                lineHeight: 1.6,
                                textAlign: 'start'
                            }}
                        >
                            {description}
                        </Typography>
                    </CardUI>
                </Box>
            </Box>
        </Box>
    );
};



const LatestSteps: React.FC = () => {
    const [tab, setTab] = useState<"org" | "ind">("org");
    const [activeCard, setActiveCard] = useState<CardData | null>(null);
    const [activeOrgCard, setActiveOrgCard] = useState<CardData | null>(null);
    const activeCards = tab === "org" ? organizationalSteps : individualSteps;
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    // Content modals
    const [open, setOpen] = useState(false);
    const [orgPopupOpen, setOrgPopupOpen] = useState(false);

    // Forms
    const [mentoringFormOpen, setMentoringFormOpen] = useState(false);
    const [mentoringFormVariant, setMentoringFormVariant] =
        useState<"individual" | "organizational">("individual");
    const [flippedIndex, setFlippedIndex] = useState<number | null>(null);



    return (
        <Box
            sx={{
                width: "100%",
                minHeight: { xs: 1110, md: 1140 },
                backgroundColor: "#eef2f7",
                position: "relative",
                overflow: "hidden",
                boxShadow: "inset 0 -50px 90px rgba(15,23,42,0.1)",
                pt: 14,
            }}
        >
            <Box>
                <SmoothWaveText
                    variant="h3"
                    sx={{
                        fontSize: { xs: 42, md: 72 },
                        fontWeight: 700,
                        color: 'primary.main',
                        mt: 4
                    }}
                >
                    Sales Excellence Starts Here
                </SmoothWaveText>
            </Box>
            {/* Glass Tabs */}
            <Box
                sx={{
                    position: "relative",
                    display: "flex",
                    justifyContent: "center",
                    pt: 2,
                    pb: { xs: 0, md: 9 },
                    zIndex: 5,
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        gap: 1,
                        padding: "6px",
                        borderRadius: "999px",
                        background:
                            "linear-gradient(180deg, rgba(255,255,255,0.65), rgba(255,255,255,0.35))",
                        backdropFilter: "blur(14px)",
                        border: "1px solid rgba(255,255,255,0.7)",
                        boxShadow: "0 12px 28px rgba(15,23,42,0.18)",
                    }}
                >
                    {[
                        { key: "org", label: "Organizational" },
                        { key: "ind", label: "Individual" },
                    ].map((t) => (
                        <Box
                            key={t.key}
                            onClick={() => setTab(t.key as "org" | "ind")}
                            sx={{
                                cursor: "pointer",
                                px: 3,
                                py: 1.2,
                                borderRadius: "999px",
                                fontWeight: 600,
                                fontSize: { xs: 16, md: 20 },
                                color: tab === t.key ? "#0b1220" : "rgba(15,23,42,0.6)",
                                background:
                                    tab === t.key
                                        ? "linear-gradient(180deg, #ffffff, #3970a7)"
                                        // "linear-gradient(180deg, #ffffff, #f1f5f9)"
                                        : "transparent",
                                boxShadow:
                                    tab === t.key
                                        ? "0 6px 14px rgba(15,23,42,0.18)"
                                        : "none",
                                transition: "all 0.3s ease",
                            }}
                        >
                            {t.label}
                        </Box>
                    ))}
                </Box>
            </Box>

            {/* Bottom Curve */}
            <Box
                sx={{
                    position: "absolute",
                    top: { xs: '10%', md: '20%' },
                    left: "50%",
                    transform: "translateX(-50%)",
                    zIndex: 1,
                    filter: "drop-shadow(0 20px 34px rgba(15,23,42,0.28))",
                }}
            >
                <Box
                    component="img"
                    src={glasscurve}
                    alt="Glass Curve"
                    sx={{
                        width: { xs: 740, md: 940 },
                        maxWidth: "90vw",
                        display: { xs: 'none', md: 'block' },
                    }}
                />
            </Box>

            {/* Cards */}
            {activeCards.map((card, index) => {
                const isLast = index === activeCards.length - 1;
                const stepNumber = index + 2;

                return (
                    <Box
                        key={index}
                        sx={{
                            position: "absolute",
                            left: {
                                xs: card.left.xs,
                                md: card.left.md,
                                lg: card.left.lg,
                            },
                            top: {
                                xs: card.top.xs,
                                md: card.top.md,
                                lg: card.top.lg,
                            },
                            transform: "translateX(-50%)",
                            zIndex: 3,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                        }}
                    >
                        {/* CARD */}
                        <StepCard
                            index={index}
                            isFlipped={flippedIndex === index}
                            onHover={() => setFlippedIndex(index)}
                            step={card.step}
                            year={card.year}
                            title={card.title}
                            description={card.description}
                            onViewMore={() => {
                                if (tab === "ind") {
                                    setActiveCard(card);
                                    setOpen(true);
                                } else {
                                    setActiveOrgCard(card);
                                    setOrgPopupOpen(true);
                                }
                            }}
                        />


                        {/* ================= DESKTOP VERTICAL LINE ================= */}
                        {!isMobile && (
                            <Box
                                sx={{
                                    width: "4px",
                                    height: 110,
                                    background:
                                        "linear-gradient(180deg, rgba(255,255,255,0.9), rgba(255,255,255,0.35))",
                                    mt: "6px",
                                    borderRadius: "4px",
                                }}
                            />
                        )}

                        {/* ================= MOBILE CONNECTOR + CIRCLE ================= */}
                        {isMobile && !isLast && (
                            <>
                                {/* TOP LINE */}
                                {/* <Box
                                    sx={{
                                        width: "2px",
                                        height: 22,
                                        background: "rgba(15,23,42,0.18)",
                                        mt: "6px",
                                        borderRadius: "2px",
                                    }}
                                /> */}

                                {/* 3D CIRCLE */}
                                {/* <Box
                                    sx={{
                                        width: 44,
                                        height: 44,
                                        borderRadius: "50%",
                                        background: "#eef2f7",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        boxShadow:
                                            "0 10px 22px rgba(15,23,42,0.25), inset 0 2px 4px rgba(255,255,255,0.9)",
                                        border: "2px solid rgba(15,23,42,0.15)",
                                    }}
                                >
                                    <Box
                                        sx={{
                                            width: 30,
                                            height: 30,
                                            borderRadius: "50%",
                                            background: "linear-gradient(180deg, #ffffff, #1b7bac)",
                                            // "linear-gradient(180deg, #ffffff, #dbe4ff)",
                                            boxShadow:
                                                "inset 0 2px 6px rgba(15,23,42,0.18)",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            fontWeight: 700,
                                            fontSize: 14,
                                            color: "#0b1220",
                                        }}
                                    >
                                        {stepNumber}
                                    </Box>
                                </Box> */}

                                {/* BOTTOM LINE */}
                                {/* <Box
                                    sx={{
                                        width: "2px",
                                        height: 26,
                                        background: "rgba(15,23,42,0.18)",
                                        mt: "4px",
                                        borderRadius: "2px",
                                    }}
                                /> */}
                            </>
                        )}
                    </Box>
                );
            })}

            {/* ================= INDIVIDUAL POPUP MODAL ================= */}
            <Modal open={open} onClose={() => setOpen(false)}>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: { xs: "92%", sm: 600, md: 900 },
                        height: { xs: "69vh", md: "88vh" },
                        bgcolor: "#fff",
                        borderRadius: 2,
                        boxShadow: 24,
                        display: "flex",
                        flexDirection: "column",
                        overflow: "hidden",
                    }}
                >
                    {/* HEADER */}
                    <Box
                        sx={{
                            position: "relative",
                            px: 3,
                            pt: 3,
                            pb: 1.5,
                            flexShrink: 0,
                        }}
                    >
                        <IconButton
                            onClick={() => setOpen(false)}
                            sx={{
                                position: "absolute",
                                right: 2,
                                top: 12,
                                color: "#0f63a5",
                                zIndex: 2,
                            }}
                        >
                            <CloseIcon />
                        </IconButton>

                        <Box
                            sx={{
                                bgcolor: "#0f63a5",
                                borderRadius: 1,
                                px: 3,
                                py: 2,
                                width: { xs: "80%", md: "90%" },
                            }}
                        >
                            <Typography
                                variant="h4"
                                sx={{
                                    color: "#fff",
                                    fontWeight: 700,
                                    lineHeight: 1.2,
                                }}
                            >
                                {activeCard?.popupTitle}
                            </Typography>

                            {activeCard?.popupSubTitle && (
                                <Typography
                                    variant="body2"
                                    sx={{
                                        color: "#fff",
                                        opacity: 0.9,
                                        mt: 0.5,
                                    }}
                                >
                                    {activeCard.popupSubTitle}
                                </Typography>
                            )}
                        </Box>
                    </Box>

                    {/* SCROLLABLE CONTENT */}
                    <Box
                        sx={{
                            flex: 1,
                            overflowY: "auto",
                            px: { xs: 2, md: 4 },
                            py: 3,
                        }}
                    >
                        {/* Intro */}
                        {activeCard?.popupIntro?.map((text, i) => (
                            <Typography variant="body2" key={i} sx={{ mb: 1.6, lineHeight: 1.6 }}>
                                {text}
                            </Typography>
                        ))}

                        {/* What You'll Work On */}
                        {activeCard?.workOn && (
                            <>
                                <Typography variant="h6" sx={{ mt: 3, mb: 1.5, fontWeight: 700 }}>
                                    What You'll Work On
                                </Typography>

                                {activeCard.workOn.map((item, i) => (
                                    <Box
                                        key={i}
                                        sx={{
                                            display: "flex",
                                            alignItems: "flex-start",
                                            mb: 1,
                                        }}
                                    >
                                        <Box
                                            component="img"
                                            src={CheckMarkIcon}
                                            alt="Checkmark"
                                            sx={{
                                                width: 16,
                                                height: 16,
                                                mt: "4px",
                                                mr: 1.5,
                                                flexShrink: 0,
                                            }}
                                        />
                                        <Typography variant="body2" sx={{ lineHeight: 1.5 }}>
                                            {item}
                                        </Typography>
                                    </Box>
                                ))}
                            </>
                        )}

                        {/* Who This Is For */}
                        {activeCard?.whoFor && (
                            <>
                                <Typography variant="h6" sx={{ mt: 3, mb: 1.5, fontWeight: 700 }}>
                                    Who This Is For
                                </Typography>

                                {activeCard.whoFor.map((item, i) => (
                                    <Typography variant="body2" key={i} sx={{ mb: 0.8 }}>
                                        • {item}
                                    </Typography>
                                ))}
                            </>
                        )}

                        {/* Outcome */}
                        {activeCard?.outcome && (
                            <>
                                <Typography variant="h6" sx={{ mt: 3, mb: 1.5, fontWeight: 700 }}>
                                    {activeCard.outcomeTitle}
                                </Typography>

                                {activeCard.outcome.map((item, i) => (
                                    <Typography variant="body2" key={i} sx={{ mb: 0.8 }}>
                                        • {item}
                                    </Typography>
                                ))}
                            </>
                        )}
                    </Box>

                    {/* FIXED FOOTER / CTA */}
                    <Box
                        sx={{
                            px: 3,
                            py: 2,
                            borderTop: "1px solid rgba(0,0,0,0.08)",
                            flexShrink: 0,
                            display: "flex",
                            justifyContent: "start",
                            bgcolor: "#fff",
                        }}
                    >
                        <Button
                            variant="contained"
                            sx={{
                                backgroundColor: "#0f63a5",
                                px: 5,
                                py: 1.3,
                                borderRadius: "10px",
                                fontWeight: 600,
                                textTransform: "none",
                            }}
                            onClick={() => {
                                setOpen(false);
                                setMentoringFormVariant("individual");
                                setMentoringFormOpen(true);
                            }}
                        >
                            {activeCard?.ctaText || "Enquire Now"}

                        </Button>
                    </Box>
                </Box>
            </Modal>

            {/* ================= ORGANIZATIONAL POPUP MODAL ================= */}
            <Modal open={orgPopupOpen} onClose={() => setOrgPopupOpen(false)}>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: { xs: "92%", sm: 600, md: 900 },
                        height: { xs: "69vh", md: "88vh" },
                        bgcolor: "#fff",
                        borderRadius: 2,
                        boxShadow: 24,
                        display: "flex",
                        flexDirection: "column",
                        overflow: "hidden",
                    }}
                >
                    {/* HEADER */}
                    <Box
                        sx={{
                            position: "relative",
                            px: 3,
                            pt: 3,
                            pb: 1.5,
                            flexShrink: 0,
                        }}
                    >
                        <IconButton
                            onClick={() => setOrgPopupOpen(false)}
                            sx={{
                                position: "absolute",
                                right: 2,
                                top: 12,
                                color: "#0f63a5",
                                zIndex: 2,
                            }}
                        >
                            <CloseIcon />
                        </IconButton>

                        <Box
                            sx={{
                                bgcolor: "#0f63a5",
                                borderRadius: 1,
                                px: 3,
                                py: 2,
                                width: { xs: "80%", md: "90%" },
                            }}
                        >
                            <Typography
                                variant="h4"
                                sx={{
                                    color: "#fff",
                                    fontWeight: 700,
                                    lineHeight: 1.2,
                                }}
                            >
                                {activeOrgCard?.popupTitle}
                            </Typography>

                            {activeOrgCard?.popupSubTitle && (
                                <Typography
                                    variant="body2"
                                    sx={{
                                        color: "#fff",
                                        opacity: 0.9,
                                        mt: 0.5,
                                    }}
                                >
                                    {activeOrgCard.popupSubTitle}
                                </Typography>
                            )}
                        </Box>
                    </Box>

                    {/* SCROLLABLE CONTENT */}
                    <Box
                        sx={{
                            flex: 1,
                            overflowY: "auto",
                            px: { xs: 2, md: 4 },
                            py: 3,
                        }}
                    >
                        {/* Intro */}
                        {activeOrgCard?.popupIntro?.map((text, i) => (
                            <Typography variant="body2" key={i} sx={{ mb: 1.6, lineHeight: 1.6 }}>
                                {text}
                            </Typography>
                        ))}

                        {/* What You'll Work On */}
                        {activeOrgCard?.workOn && (
                            <>
                                <Typography variant="h6" sx={{ mt: 3, mb: 1.5, fontWeight: 700 }}>
                                    What You'll Work On
                                </Typography>

                                {activeOrgCard.workOn.map((item, i) => (
                                    <Box
                                        key={i}
                                        sx={{
                                            display: "flex",
                                            alignItems: "flex-start",
                                            mb: 1,
                                        }}
                                    >
                                        <Box
                                            component="img"
                                            src={CheckMarkIcon}
                                            alt="Checkmark"
                                            sx={{
                                                width: 16,
                                                height: 16,
                                                mt: "4px",
                                                mr: 1.5,
                                                flexShrink: 0,
                                            }}
                                        />
                                        <Typography variant="body2" sx={{ lineHeight: 1.5 }}>
                                            {item}
                                        </Typography>
                                    </Box>
                                ))}
                            </>
                        )}

                        {/* Who This Is For */}
                        {activeOrgCard?.whoFor && (
                            <>
                                <Typography variant="h6" sx={{ mt: 3, mb: 1.5, fontWeight: 700 }}>
                                    Who This Is For
                                </Typography>

                                {activeOrgCard.whoFor.map((item, i) => (
                                    <Typography variant="body2" key={i} sx={{ mb: 0.8 }}>
                                        • {item}
                                    </Typography>
                                ))}
                            </>
                        )}

                        {/* Outcome */}
                        {activeOrgCard?.outcome && (
                            <>
                                <Typography variant="h6" sx={{ mt: 3, mb: 1.5, fontWeight: 700 }}>
                                    {activeOrgCard.outcomeTitle}
                                </Typography>

                                {activeOrgCard.outcome.map((item, i) => (
                                    <Typography variant="body2" key={i} sx={{ mb: 0.8 }}>
                                        • {item}
                                    </Typography>
                                ))}
                            </>
                        )}
                    </Box>

                    {/* FIXED FOOTER / CTA */}
                    <Box
                        sx={{
                            px: 3,
                            py: 2,
                            borderTop: "1px solid rgba(0,0,0,0.08)",
                            flexShrink: 0,
                            display: "flex",
                            justifyContent: "start",
                            bgcolor: "#fff",
                        }}
                    >
                        <Button
                            variant="contained"
                            sx={{
                                backgroundColor: "#0f63a5",
                                px: 5,
                                py: 1.3,
                                borderRadius: "999px",
                                fontWeight: 600,
                                textTransform: "none",
                            }}
                            onClick={() => {
                                setOrgPopupOpen(false);
                                setMentoringFormVariant("organizational");
                                setMentoringFormOpen(true);
                            }}
                        >
                            {activeOrgCard?.ctaText || "Enquire Now"}
                        </Button>
                    </Box>
                </Box>
            </Modal>

            {/* ================= MENTORING FORM MODAL ================= */}
            <Modal open={mentoringFormOpen} onClose={() => setMentoringFormOpen(false)}>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: { xs: "92%", sm: 520, md: 720 },
                        maxHeight: { xs: "80vh", md: "85vh" },
                        overflowY: "auto",
                        bgcolor: "#fff",
                        borderRadius: 2,
                        boxShadow: 24,
                        p: { xs: 2, sm: 3 },
                    }}
                >
                    <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                        <IconButton onClick={() => setMentoringFormOpen(false)}>
                            <CloseIcon />
                        </IconButton>
                    </Box>

                    {mentoringFormVariant === "individual" ? (
                        <IndividualMentoringForm />
                    ) : (
                        <OrganizationalMentoringForm />
                    )}
                </Box>
            </Modal>
        </Box>
    );
};

export default LatestSteps;
